module.exports = __webpack_public_path__ + "static/buildup_img2-46103ce982973eaed4d0261af1e9f6f3.png";